import { render, staticRenderFns } from "./ModalEditTemporaryPassword.vue?vue&type=template&id=3ebf1894&scoped=true&lang=pug&"
import script from "./ModalEditTemporaryPassword.vue?vue&type=script&lang=ts&"
export * from "./ModalEditTemporaryPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf1894",
  null
  
)

export default component.exports